import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Teachers from "../components/structureComponent/teachersComponent";
import Footer from "../components/footerComponent/footer";

export default function TeachersPage() {
    return (
        <Layout>
            <Header/>
            <Teachers/>
            <Footer/>
        </Layout>
    );
};